import { render, staticRenderFns } from "./MedicalInformationCN.vue?vue&type=template&id=19510cee"
import script from "./MedicalInformationCN.vue?vue&type=script&lang=js"
export * from "./MedicalInformationCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports